import { useEffect, useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';

export function ContactPopup() {
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  const [contactData, setContactData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  useEffect(() => {
    const openPopup = () => {
      if (!hasOpened) {
        setOpen(true);
        setHasOpened(true);
        removeListeners();
      }
    };

    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const halfPage = document.body.scrollHeight / 2;
      if (scrolled >= halfPage) {
        openPopup();
      }
    };

    const timer = setTimeout(() => {
      openPopup();
    }, 15000);

    const removeListeners = () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      removeListeners();
    };
  }, [hasOpened]);

  const handleClose = () => setOpen(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const params = new URLSearchParams(
        contactData as Record<string, string>
      ).toString();

      const url = `https://script.google.com/macros/s/AKfycbzhK_bO8zhduV6OJWLz2i5gvDW411IlofCZuo-XuKPLH-aQ7iMGP9jQ7E-zyeheCRs5/exec?${params}`;

      const res = await fetch(url, { method: 'GET' });

      if (res.ok) {
        alert(`תודה שפנית אלינו, ${contactData.name}!`);
        setContactData({ name: '', phone: '', email: '', message: '' });
        setOpen(false);
      } else {
        alert('אירעה שגיאה בשליחת הטופס, נסה שוב מאוחר יותר.');
      }
    } catch (err) {
      alert('אירעה שגיאה בשליחת הטופס, נסה שוב מאוחר יותר.');
    }

    setLoading(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          p: 4,
          backgroundColor: 'background.paper',
          borderRadius: 3,
          boxShadow: 6,
          width: '90%',
          maxWidth: 400,
          mx: 'auto',
          mt: '15vh',
          direction: 'rtl',
        }}
      >
        <Typography variant="h6" gutterBottom>
          דברו איתנו👋
        </Typography>
        <TextField
          label="שם"
          fullWidth
          margin="normal"
          name="name"
          value={contactData.name}
          onChange={handleInputChange}
          required
        />
        <TextField
          label="טלפון"
          fullWidth
          margin="normal"
          name="phone"
          value={contactData.phone}
          onChange={handleInputChange}
          required
        />
        <TextField
          label="אימייל"
          fullWidth
          margin="normal"
          name="email"
          type="email"
          value={contactData.email}
          onChange={handleInputChange}
          required
        />
        <TextField
          label="מה תרצו?"
          fullWidth
          margin="normal"
          name="message"
          multiline
          rows={3}
          value={contactData.message}
          onChange={handleInputChange}
          required
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          {loading ? 'שולח...' : 'שליחה'}
        </Button>
      </Box>
    </Modal>
  );
}
